import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=b20f64c0&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=b20f64c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f64c0",
  null
  
)

export default component.exports